import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, ControlLabel, Form, FormGroup } from 'react-bootstrap';
import './NewBuildingModal.css';
import FormModal from 'components/shared/modal/FormModal';
import {
  getBuildingForm,
  getShowNewBuildingModal,
  getProjectForm,
} from 'components/admin/projects/creation/store/selectors';
import Input from 'components/shared/input/Input';
import {
  setBuildingFormValue,
  createBuilding,
  setShowNewBuildingModal,
  cleanBuildingFormValues,
} from 'components/admin/projects/creation/store/actions';
import { addBuildingToBeginning } from 'actions/admin/work-orders/work-orders.js';

class NewBuildingModal extends Component {
  constructor(props) {
    super(props);
    props.dispatch(cleanBuildingFormValues());
  }

  handleBuildingFormChange = (attribute, value) => {
    this.props.dispatch(setBuildingFormValue(attribute, value));
  };

  handleClose = () => {
    this.props.dispatch(setShowNewBuildingModal(false));
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { dispatch } = this.props;
    const buildingData = this.mapBuildingData();
    dispatch(createBuilding(buildingData)).then((response) => {
      if (response.ok) {
        dispatch(addBuildingToBeginning(response.building));
        dispatch(setShowNewBuildingModal(false));
      }
    });
  };

  buildingFormValid = () => {
    const buildingForm = this.props.form;
    return (
      !!buildingForm.streetAddress1 &&
      !!buildingForm.city &&
      !!buildingForm.state &&
      !!buildingForm.zip
    );
  };

  mapBuildingData = () => {
    const buildingForm = this.props.form;
    return {
      name: buildingForm.name,
      location: {
        streetAddress: buildingForm.streetAddress1,
        unitNumber: buildingForm.streetAddress2,
        city: buildingForm.city,
        state: buildingForm.state,
        zipCode: buildingForm.zip,
      },
      clientsId: [this.props.projectForm.clientId],
    };
  };

  render() {
    return (
      <div id="new-building-form-modal">
        <FormModal
          className="new-building-modal"
          show={this.props.showNewBuildingModal}
          title={'New Building Information'}
          onClose={this.handleClose}
        >
          <Form horizontal onSubmit={this.handleSubmit}>
            <FormGroup>
              <Col componentClass={ControlLabel} sm={4}>
                Building Name
              </Col>
              <Col sm={8}>
                <Input
                  id="name"
                  placeholder="Building Name"
                  value={this.props.form.name}
                  theme="normal"
                  onChange={this.handleBuildingFormChange.bind(this, 'name')}
                />
              </Col>
            </FormGroup>

            <hr />

            <FormGroup>
              <Col componentClass={ControlLabel} sm={4}>
                Address Line 1
              </Col>
              <Col sm={8}>
                <Input
                  id="street-address-1"
                  placeholder="Street Address"
                  value={this.props.form.streetAddress1}
                  theme="normal"
                  onChange={this.handleBuildingFormChange.bind(
                    this,
                    'streetAddress1'
                  )}
                />
              </Col>
            </FormGroup>

            <FormGroup>
              <Col componentClass={ControlLabel} sm={4}>
                Address Line 2
              </Col>
              <Col sm={8}>
                <Input
                  id="street-address-2"
                  placeholder="Unit number / Floor"
                  value={this.props.form.streetAddress2}
                  theme="normal"
                  onChange={this.handleBuildingFormChange.bind(
                    this,
                    'streetAddress2'
                  )}
                />
              </Col>
            </FormGroup>

            <FormGroup>
              <Col componentClass={ControlLabel} sm={4}>
                City
              </Col>
              <Col sm={8}>
                <Input
                  id="city"
                  placeholder="City"
                  theme="normal"
                  value={this.props.form.city}
                  onChange={this.handleBuildingFormChange.bind(this, 'city')}
                />
              </Col>
            </FormGroup>

            <FormGroup>
              <Col componentClass={ControlLabel} sm={4}>
                State / Zip
              </Col>
              <Col sm={5}>
                <Input
                  id="state"
                  placeholder="State"
                  value={this.props.form.state}
                  theme="normal"
                  onChange={this.handleBuildingFormChange.bind(this, 'state')}
                />
              </Col>
              <Col sm={3}>
                <Input
                  id="zip"
                  placeholder="Zip"
                  value={this.props.form.zip}
                  theme="normal"
                  onChange={this.handleBuildingFormChange.bind(this, 'zip')}
                />
              </Col>
            </FormGroup>

            <FormGroup className="button-container">
              <Col sm={3}>
                <input
                  className={`btn button button-continue ${
                    this.buildingFormValid()
                      ? 'button-orange'
                      : 'button-disabled'
                  }`}
                  type="submit"
                  value="Add"
                  disabled={!this.buildingFormValid()}
                />
              </Col>
              <Col sm={3}>
                <input
                  id="cancel-add-building"
                  className="btn button button-gray"
                  value="Cancel"
                  onClick={this.handleClose}
                  readOnly={true}
                />
              </Col>
            </FormGroup>
          </Form>
        </FormModal>
      </div>
    );
  }
}

export default connect((state) => {
  return {
    form: getBuildingForm(state),
    projectForm: getProjectForm(state),
    showNewBuildingModal: getShowNewBuildingModal(state),
  };
})(NewBuildingModal);



// WEBPACK FOOTER //
// ./src/components/admin/projects/creation/NewBuildingModal.js